export default function bindAll(context, methods = []) {
  const limit = methods.length;
  let index;
  let method;

  for (index = 0; index < limit; index++) {
    method = methods[index];

    if (context && context[method]) {
      context[method] = context[method].bind(context);
    }
  }
}
